import {
  EMPTY_FETCH_CORPS_MEMBER,
  FETCH_CORPS_MEMBER,
  FETCH_CORPS_MEMBER_SUCCESS,

  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_FAILURE,

  AUTH_CM_GUID,
  AUTH_CM_GUID_SUCCESS,
  AUTH_CM_GUID_FAILURE,

  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  RESTORE_CORPS_MEMBER_DETAILS,

  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  CHANGE_PASSWORD_RESET,
  FETCH_CORPS_MEMBER_FAILURE,
  REGISTER_LGI_USER,
  REGISTER_LGI_USER_SUCCESS,
  REGISTER_LGI_USER_FAILURE,
  RESTORE_LGI_USER,
  FETCH_ALL_LGI_USERS,
  FETCH_ALL_LGI_USERS_SUCCESS,
  FETCH_ALL_LGI_USERS_FAILURE,
  RELOCATE_LGI,
  RELOCATE_LGI_SUCCESS,
  RELOCATE_LGI_FAILURE,
  ACTIVATE_LGI,
  ACTIVATE_LGI_SUCCESS,
  ACTIVATE_LGI_FAILURE,
  DEACTIVATE_LGI,
  DEACTIVATE_LGI_SUCCESS,
  DEACTIVATE_LGI_FAILURE,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
} from "../ActionTypes";


// To log in new user
export const userLogin = (payload) => ({
  type: LOGIN_USER,
  payload

});

export const userLoginSuccess = (payload) => {
  return {
    type: LOGIN_USER_SUCCESS,
    payload
  }
};

export const userLoginFailure = (payload) => ({
  type: LOGIN_USER_FAILURE,
  payload
})

export const authCmGuid = payload => ({
  type: AUTH_CM_GUID,
  payload
})

export const authCmGuidSuccess = payload => ({
  type: AUTH_CM_GUID_SUCCESS,
  payload
})

export const authCmGuidFailure = payload => ({
  type: AUTH_CM_GUID_FAILURE,
  payload
})

// To log out new user
export const userLogout = () => ({
  type: LOGOUT_USER,

});

export const userLogoutSuccess = (payload) => ({
  type: LOGOUT_USER_SUCCESS,
  payload

});


// To fetch single corps member
export const fetchCorpsMember = (payload) => ({
  type: FETCH_CORPS_MEMBER,
  payload

});

export const fetchCorpsMemberSuccess = (payload) => ({
  type: FETCH_CORPS_MEMBER_SUCCESS,
  payload

});

export const fetchCorpsMemberFailure = (payload) => ({
  type: FETCH_CORPS_MEMBER_FAILURE,
  payload

});


// To empty single corps member
export const emptyCorpsMember = () => ({
  type: EMPTY_FETCH_CORPS_MEMBER,
});

export const RestoreCorpsMember = () => ({
  type: RESTORE_CORPS_MEMBER_DETAILS,
})


// To change LGI password (specifically)
export const changePassword = payload => ({
  type: CHANGE_PASSWORD,
  payload
})

export const changePasswordSuccess = payload => ({
  type: CHANGE_PASSWORD_SUCCESS,
  payload
})

export const changePasswordFailure = payload => ({
  type: CHANGE_PASSWORD_FAILURE,
  payload
})

export const changePasswordReset = payload => ({
  type: CHANGE_PASSWORD_RESET,
  payload
})


export const registerLGIUser = payload => ({
  type: REGISTER_LGI_USER,
  payload
})

export const registerLGIUserSuccess = payload => ({
  type: REGISTER_LGI_USER_SUCCESS,
  payload
})

export const registerLGIUserFailure = payload => ({
  type: REGISTER_LGI_USER_FAILURE,
  payload
})

export const restoreLGIUser = () => ({
  type: RESTORE_LGI_USER,
})

export const fetchAllLGIUsers = payload => ({
  type: FETCH_ALL_LGI_USERS,
  payload
})

export const fetchAllLGIUsersSuccess = payload => ({
  type: FETCH_ALL_LGI_USERS_SUCCESS,
  payload
})

export const fetchAllLGIUsersFailure = payload => ({
  type: FETCH_ALL_LGI_USERS_FAILURE,
  payload
})

export const relocateLGI = payload => ({
  type: RELOCATE_LGI,
  payload
})

export const relocateLGISuccess = payload => ({
  type: RELOCATE_LGI_SUCCESS,
  payload
})

export const relocateLGIFailure = payload => ({
  type: RELOCATE_LGI_FAILURE,
  payload
})


export const engageLGI = payload => ({
  type: ACTIVATE_LGI,
  payload
})

export const engageLGISuccess = payload => ({
  type: ACTIVATE_LGI_SUCCESS,
  payload
})

export const engageLGIFailure = payload => ({
  type: ACTIVATE_LGI_FAILURE,
  payload
})

export const disengageLGI = payload => ({
  type: DEACTIVATE_LGI,
  payload
})

export const disengageLGISuccess = payload => ({
  type: DEACTIVATE_LGI_SUCCESS,
  payload
})

export const disengageLGIFailure = payload => ({
  type: DEACTIVATE_LGI_FAILURE,
  payload
})


export const resetPassword = payload => ({
  type: RESET_PASSWORD,
  payload
})

export const resetPasswordSuccess = payload => ({
  type: RESET_PASSWORD_SUCCESS,
  payload
})

export const resetPasswordFailure = payload => ({
  type: RESET_PASSWORD_FAILURE,
  payload
})